<!--
 * @Author: cryi.liu
 * @Date: 2020-05-06 16:01:40
 * @LastEditTime: 2020-06-13 09:30:13
 * @Description: 数据表格分页
 -->
<template>
   <i-page
    :total="total"
    :current="page.index"
    :page-size="page.size"
    size="small"
    show-elevator show-total @on-change="pageIndexChanged" />
</template>

<script>
export default {
  name: 'DataPage',
  props: {
    total: { type: Number, required: true },
    page: { type: Object, required: true },
  },
  methods: {
    /**
     * 分页索引发生改变
     */
    pageIndexChanged(index) {
      this.$emit('index-change', index);
    },
  },
};
</script>
